<template>
    <CrudList
      title="Pedidos de liquidación"
      storeName="Request_extraction"
      :canAdd="false"
      :canSearch="false"
      sortable
      :singleSelect="false"
      :showSelect="true"
      :actions="actions"
    >
      <template v-slot:updated_at="{item}">
        <v-row align="center" justify="center">
          <v-col cols="12">
            <p>{{ item.updated_at ? formatDateTime(item.updated_at) : '' }}</p>
          </v-col>
        </v-row>
      </template>
      <template v-slot:pesos_quantity="{ item }">
        <p class="mb-0 text-right text-no-wrap">
          {{
            formatUSD(
                Number(item.pesos_quantity) ||
                0 /* -
              calculateCommission(item.total, item.commission_percentage) */
            )
          }}
        </p>
      </template>
    </CrudList>
  </template>
  
  <script>
  import CrudList from "@/components/Crud/CrudList";
  import CrudFormMixin from "@/mixins/crud_form";
  import {format} from "currency-formatter";

  export default {
    mixins: [CrudFormMixin],
    components: { CrudList },
    data() {
      return {
        actions: [
          { label: 'PAGADO', action: this.onChangePaid },
          { label: 'PENDIENTE', action: this.onChangePending },
        ]
      };
    },
    methods: {
      async onChangePaid(items){
        const itemsFiltered = items.filter(obj => obj.hasOwnProperty('id'));
        const ids = itemsFiltered.map(objeto => objeto.id);

        console.log('ids', ids);
        
        await this.$store.dispatch("Request_extraction/updateAllStatus", { ids: ids, status: 'paid'})
        await this.$store.dispatch("Request_extraction/getList", {sortBy: [], sortDesc: []});          
        
        
      },
      async onChangePending(items){
        const itemsFiltered = items.filter(obj => obj.hasOwnProperty('id'));
        const ids = itemsFiltered.map(objeto => objeto.id);
      
        await this.$store.dispatch("Request_extraction/updateAllStatus", { ids: ids, status: 'pending'})
        await this.$store.dispatch("Request_extraction/getList", {sortBy: [], sortDesc: []});          
        
      },
      formatUSD(value) {
        return format(Number(value).toFixed(2), {
          code: "USD",
          decimal: ",",
          thousand: ".",
          format: "%s %v",
        });
      },

    },
  };
  </script>
  